// extracted by mini-css-extract-plugin
export default {"data-empty":"data-empty--bcu32","title":"title--QTeGt","editEmptyTitle":"editEmptyTitle--k45tM","pic":"pic--WGO9r","img":"img--boezZ","tip":"tip--xcLv1"};